/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop, Watch } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM } from 'src/util/bem';
import './overproofDistribution.less';
import IndexPageApi from '../api/IndexPage';
import { CommonUtil } from 'src/util/commonUtil';
let bem = createBEM('overproof-distribution');

@Component
export default class OverproofDistribution extends Vue.Component<{type: number}> {
    @Prop({
        type: Number,
    })
    type!: number;

    normalCount: number = 0;
    overproofCount: number = 0;
    severityCount: number = 0;
    total = 0;

    @Watch('type')
    typeChange() {
        this.search();
    }
    async search() {
        let { code, data } = await IndexPageApi.searchOverproof(this.type);
        if (code === 0) {
            this.total = data.normal_count + data.overproof_count + data.severity_count;
            this.normalCount = data.normal_count;
            this.overproofCount = data.overproof_count;
            this.severityCount = data.severity_count;
        }
    }

    async mounted() {
        this.search()
    }
    renderPercent(h, percent: number, text) {
        return (
            <div class={bem('pecent-wrapper')}>
                <div class={bem('percent')}>
                    <div style={{ width: percent + '%' }} />
                </div>
                <div>{text}</div>
                <div>{percent}%</div>
            </div>
        );
    }
    render(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')}>超标分布情况</div>
                <div class={bem('content')}>
                    <div class={bem('row')}>
                        <div class={bem('count')}>{this.normalCount}</div>
                        {this.renderPercent(h, +CommonUtil.toFixed((this.normalCount / this.total) * 100, 2),'正常')}
                    </div>
                    <div class={bem('row')}>
                        <div class={bem('count')}> {this.overproofCount}</div>
                        {this.renderPercent(h, +CommonUtil.toFixed((this.overproofCount / this.total) * 100, 2),'超标')}
                    </div>
                    <div class={bem('row')}>
                        <div class={bem('count')}>{this.severityCount}</div>
                        {this.renderPercent(h, +CommonUtil.toFixed((this.severityCount / this.total) * 100, 2),'严重超标')}
                    </div>
                </div>
            </div>
        );
    }
}
